import React from 'react'
import PropTypes from 'prop-types'

import MergeTicketsModalForm from './MergeTicketsModalForm'

import Modal from 'Components/Modal'

const MergeTicketsModal = ({
  showModal,
  removeModal,
  ticketsToMerge
}) => (
  <div>
    <Modal
      showModal={showModal}
      title="Merge Tickets"
      removeModal={() => removeModal()}
      largeModal
    >
      <MergeTicketsModalForm
        ticketsToMerge={ticketsToMerge}
      />
    </Modal>
  </div>
)

MergeTicketsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  removeModal: PropTypes.func.isRequired,
  ticketsToMerge: PropTypes.arrayOf(PropTypes.number).isRequired
}

export default MergeTicketsModal
